import { RouteRecordRaw } from 'vue-router'

const productSetRoutes: RouteRecordRaw = {
  path: 'productSets',
  name: 'ProductSet',
  component: () =>
    import('@/views/ProductsetListing/wrapper/ProductSetListingWrapper.vue'),
  meta: {
    title: 'Product Set'
  },
  beforeEnter: async (to, from, next) => {
    next()
  }
}

export default productSetRoutes
